import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import { accountLink } from '../constants/endspoints';

const Success = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
            <i className="text-success fa fa-circle-check fs-1" />
            <h2 className="mt-3 fw-bold text-light">Email Vérifié Avec Succès</h2>
            <p className="text-secondary">
                Votre email a été vérifié avec succès. Vous pouvez maintenant accéder à toutes les fonctionnalités de la plateforme.
            </p>
            <NavLink to={accountLink} className="btn btn-success px-4 py-2 rounded-pill">
                <span className='text-white'>Se connecter</span>
            </NavLink>
        </div>
    )
}

export default Success